import {
    fetchMerchantSubscriptions,
    MerchantSubscriptionsResponse,
    ShopsQuery,
} from "../../../../../merchant/admin/shops/shopsApi"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import OutlinedInput from "@mui/material/OutlinedInput"
import MenuItem from "@mui/material/MenuItem"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import * as React from "react"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { MenuProps } from "../../../../../../shared/components/filters/constants/filterMenuConst"

type MerchantSubscriptionsFilterProps = Readonly<{
    value: string[]
    setValue: (value: string[]) => void
    merchantId?: string
}>

const useStyles = makeStyles()(() => ({
    input: {
        width: "20rem",
    },
}))

function transformData(data: MerchantSubscriptionsResponse) {
    return data.subscriptionTypes
}

export function MerchantSubscriptionsFilter({ merchantId, value, setValue }: MerchantSubscriptionsFilterProps) {
    const { classes } = useStyles()

    const { data } = useApiQuery(fetchMerchantSubscriptions, {
        queryName: ShopsQuery.LIST_SUBSCRIPTIONS,
        dependencies: {
            merchantId: merchantId ? +merchantId : 0,
        },
        enabled: Boolean(merchantId),
        select: transformData,
    })

    const subscriptionTypesMap = React.useMemo(() => {
        const map: { [id: string]: string } = {}
        data?.forEach((subscription) => {
            map[subscription.id] = subscription.displayName
        })
        return map
    }, [data])

    const selectedSubscriptionTypes = value.map((id) => subscriptionTypesMap[id] || "")

    const handleChange = (event: SelectChangeEvent<typeof selectedSubscriptionTypes>) => {
        const {
            target: { value },
        } = event

        const selectedValues = typeof value === "string" ? value.split(",") : value
        const selectedIdValues = selectedValues
            .map((name) => Object.keys(subscriptionTypesMap).find((key) => subscriptionTypesMap[key] === name))
            .filter((id): id is string => id !== undefined)

        setValue(selectedIdValues)
    }

    return (
        <FormControl className={classes.input}>
            <LocalizedStrict id="supplier-subscriptions-drawer-subscription-label">
                <InputLabel id="multiple-checkbox-subscriptions-label">Subscriptions</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="multiple-checkbox-subscriptions-label"
                id="multiple-checkbox-subscriptions"
                multiple
                disabled={!Boolean(merchantId)}
                value={selectedSubscriptionTypes}
                onChange={handleChange}
                input={<OutlinedInput label="Subscriptions" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
            >
                {data?.map((subscription) => (
                    <MenuItem key={subscription.id} value={subscription.displayName}>
                        <Checkbox checked={selectedSubscriptionTypes.indexOf(subscription.displayName) > -1} />
                        <ListItemText primary={subscription.displayName} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
